import type TermClassType from "./TermClassType";

export default class TermTemplate {
    termClass: TermClassType;
    description: string;

    constructor(obj?: any) {
        if(obj) {
            this.termClass = obj.termClass;
            this.description = obj.description;
        }
    }
}